import { getWindow } from '@shared/services/window';
import { Constants } from '@shared/utils/constants';
import { getSpzaUserIdAndNewUserModifier } from '@shared/utils/appUtils';
const predefinedPLT = {
    scriptStart: -1,
    hydrationStart: -1
};
function currentSinceRequestStart() {
    var _getWindow_performance, _getWindow, _getWindow_performance1, _getWindow1;
    const { navigationStart = 0, requestStart = 0 } = ((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_performance = _getWindow.performance) === null || _getWindow_performance === void 0 ? void 0 : _getWindow_performance.timing) || {};
    return ((_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : (_getWindow_performance1 = _getWindow1.performance) === null || _getWindow_performance1 === void 0 ? void 0 : _getWindow_performance1.now()) - (requestStart - navigationStart);
}
export function setScriptStart() {
    predefinedPLT.scriptStart = currentSinceRequestStart();
}
export function setHydrationStart() {
    predefinedPLT.hydrationStart = currentSinceRequestStart();
}
function getAssetsLoadTime() {
    var _getWindow_performance, _getWindow, _getWindow_performance1, _getWindow1;
    const { navigationStart = 0, requestStart = 0 } = ((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_performance = _getWindow.performance) === null || _getWindow_performance === void 0 ? void 0 : _getWindow_performance.timing) || {};
    const perfEntries = ((_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : (_getWindow_performance1 = _getWindow1.performance) === null || _getWindow_performance1 === void 0 ? void 0 : _getWindow_performance1.getEntriesByType('resource')) || [];
    return perfEntries.filter(({ initiatorType })=>initiatorType === 'script' || initiatorType === 'link').map(({ name: src, responseEnd })=>({
            src,
            requestStart,
            responseEnd,
            duration: responseEnd - (requestStart - navigationStart)
        }));
}
const whiteListedAssets = [
    'staticstorage',
    'agorasstatic'
];
function getSlowestAssetDuration({ assets }) {
    return assets.filter(({ src })=>whiteListedAssets.some((whiteListedAsset)=>src.includes(whiteListedAsset))).sort((a, b)=>b.duration - a.duration)[0];
}
export function telemetryPageLoadTime({ isEmbedded, landingView }) {
    if (!getWindow()) {
        return;
    }
    const performanceNow = getWindow().performance.now();
    const { navigationStart = 0, requestStart = 0, responseStart = 0, responseEnd = 0 } = getWindow().performance.timing;
    const duration = performanceNow - (requestStart - navigationStart);
    const { scriptStart, hydrationStart } = predefinedPLT;
    const assets = getAssetsLoadTime();
    const { duration: slowestAssetDuration, src: slowestAssetURL } = getSlowestAssetDuration({
        assets
    }) || {};
    const { spzaUserId: spzaId } = getSpzaUserIdAndNewUserModifier() || {};
    const hostType = isEmbedded ? Constants.appSourceEmbed : Constants.appSource;
    const pageLoadTime = {
        hostType,
        landingView,
        responseStart: Math.max(responseStart - requestStart, 0),
        responseEnd: Math.max(responseEnd - requestStart, 0),
        scriptStart,
        hydrationStart,
        performanceNow,
        duration,
        durationSinceRequestStart: duration,
        slowestAssetDuration,
        slowestAssetURL
    };
    getWindow().pageLoadTime = pageLoadTime;
    getWindow().telemetry({
        action: Constants.Telemetry.Action.RootHandler,
        actionModifier: Constants.Telemetry.ActionModifier.End,
        details: pageLoadTime,
        spzaId
    });
    getWindow().telemetry({
        action: Constants.Telemetry.Action.PerfResources,
        actionModifier: Constants.Telemetry.ActionModifier.Complete,
        details: {
            length: assets.length,
            assets
        },
        spzaId
    });
    getWindow().flushTelemetry();
}
